document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('announcementSlider');
  if (!wrapper) return;

  const slides = wrapper.querySelectorAll('.announcement-bar__slide');
  if (slides.length <= 1) {
    if (slides[0]) slides[0].classList.add('active');
    return;
  }

  const speed = parseInt(wrapper.dataset.slideSpeed || 5, 10) * 1000;
  let currentIndex = 0;
  slides[currentIndex].classList.add('active');

  setInterval(() => {
    slides[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % slides.length;
    slides[currentIndex].classList.add('active');
  }, speed);
}); 